import posthog from 'posthog-js'

const posthogPlugin = {
  install(Vue, options) {
    Vue.prototype.$posthog = posthog.init(
      POSTHOG_API_KEY,
      {
        api_host: POSTHOG_HOST
      }
    )
  }
}

export default posthogPlugin
